import { render, staticRenderFns } from "./Permissoes.vue?vue&type=template&id=6b03e806&scoped=true"
import script from "./Permissoes.vue?vue&type=script&lang=js"
export * from "./Permissoes.vue?vue&type=script&lang=js"
import style0 from "./Permissoes.vue?vue&type=style&index=0&id=6b03e806&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b03e806",
  null
  
)

export default component.exports